/** Signal Provider bell notification REST base — matches `/api/v1/sp/rewards` pattern. */
export const SP_NOTIFICATIONS_API_BASE = '/api/v1/sp/notifications' as const
